import React from 'react'
import { createRoot } from 'react-dom/client'
import { Root } from '@/views/root'
import {
  ThemeProvider,
  themes,
  GlobalStyles,
} from '@football-australia/ui-core'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element not found')
}

const root = createRoot(container)

root.render(
  <React.StrictMode>
    <ThemeProvider theme={themes.footballaustralia.theme}>
      <GlobalStyles />
      <Root />
    </ThemeProvider>
  </React.StrictMode>
)
